import React from 'react';

const PostActions = ({ isLiked, onLike, onComment }) => {
  return (
    <div className="flex justify-around py-2 text-gray-500 border-b">
      <button
        onClick={onLike}
        className={`flex items-center space-x-1 px-4 py-2 rounded-md hover:bg-gray-100 transition-colors ${
          isLiked ? "text-blue-600" : ""
        }`}
      >
        <i className={`fas fa-thumbs-up ${isLiked ? "text-blue-600" : ""}`}></i>
        <span>{isLiked ? "Liked" : "Like"}</span>
      </button>
      
      <button
        className="flex items-center space-x-1 px-4 py-2 rounded-md hover:bg-gray-100 transition-colors"
        onClick={onComment}
      >
        <i className="far fa-comment"></i>
        <span>Comment</span>
      </button>
    </div>
  );
};

export default PostActions;